<template>
    <v-dialog v-model="active" persistent max-width="500px">
        <v-card>
            <v-card-title class="justify-center">
              <h1>{{  pedido && pedido.status_entrega === 'pendente' ? 'Informar o envio do pedido?' : 'Confirmar a entrega do pedido?' }}</h1>
            </v-card-title>
            <v-card-text v-if="pedido && pedido.status_entrega === 'em_transito'">
                <v-text-field
                  outline
                  v-model="codigo"
                  label="Código do pedido"
                  required
                  maxlength="4"
                ></v-text-field>
            </v-card-text>
            <v-card-text>
                <v-layout justify-space-around wrap class="mb-2">
                    <v-flex xs9>
                        <h6
                            class="mb-2 text-xs-center"
                            style="
                                font-size: 1.1em;
                                margin-left: 9em;
                            "
                        >
                            Digite o PIN do funcionário responsável
                        </h6>
                    </v-flex>
                    <v-flex xs2>
                        <v-icon size="40">engineering</v-icon>
                    </v-flex>
                    <v-flex xs10>
                        <h4>Lido por: {{frentista.nome}}</h4>
                        <h4>Matricula: {{frentista.matricula}}</h4>
                    </v-flex>
                </v-layout>
                <Pin v-if="!autenticado" :frentista="frentista" @autenticado="autenticado = true"/>
                <h3 v-else class="success--text text-xs-center mt-3 mb-3">Você já pode {{ pedido && pedido.status_entrega === 'pendente' ? 'informar o envio' : 'confirmar a entrega' }} do pedido</h3>
            </v-card-text>
            <v-card-actions class="justify-space-around">
                <v-flex xs6>
                    <v-btn
                        @click="$emit('fechar')"
                        flat
                        block
                    >
                        Não
                    </v-btn>
                </v-flex>
                <v-divider vertical></v-divider>
                <v-flex xs6>
                    <v-btn
                        color="success"
                        @click="mudarStatusPedido"
                        :disabled="!autenticado"
                        flat
                        block
                    >
                        SIM
                    </v-btn>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Pin from '@/components/Pin'
export default {
  props: ['pedido', 'active'],
  components: { Pin },
  data: () => ({
    autenticado: false,
    codigo: undefined
  }),
  computed: {
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    frentista () {
      return this.$store.getters.frentista
    },
    empresa () {
      return this.$store.getters.empresa
    }
  },
  watch: {
    active (val) {
      if (!val) {
        this.autenticado = false
        this.codigo = undefined
      }
    }
  },
  methods: {
    mudarStatusPedido () {
      const payload = {
        id: this.pedido.id,
        body: {
          status: this.pedido.status_entrega === 'pendente' ? 'em_transito' : 'entregue',
          codigo: this.pedido.status_entrega === 'em_transito' ? this.codigo : null,
          id_frentista: this.frentistaSelecionado.id_frentista,
          empresa: this.empresa.cnpj
        }
      }
      this.$store.dispatch('mudarStatusPedido', payload).then(() => {
        this.$emit('fechar')
      })
    }
  }
}
</script>
